import xz from "../common";
let m_publish = {
  state: {
    //初始数据
    jobType: ['全职', '兼职', '实习生', '无固定时间', '小时工日结', '临时工'], //工作类型
    // otherBtn: ['退伍军人','军人家属','在校生','其他'],
    // 优先招聘
    otherBtn: [{
      name: "退伍军人",
      value: ["army"]
    }, {
      name: "军人家属",
      value: ["family"]
    }, {
      name: "在校生",
      value: ["stu"]
    }, {
      name: "其他",
      value: ["other"]
    }], //其他要求,
    // 职位福利
    welfareTag: [{
      value: "提供住宿",
      check: false
    },{
      value: "提供工作餐",
      check: false
    },{
      value: "免费工作餐",
      check: false
    },{
      value: "免费提供住宿",
      check: false
    },{
      value: "免费包吃住",
      check: false
    },{
      value: "缴纳五险",
      check: false
    },{
      value: "缴纳五险一金",
      check: false
    },{
      value: "通讯补贴",
      check: false
    },{
      value: "定期体检",
      check: false
    },{
      value: "年终奖金",
      check: false
    },{
      value: "周末双休",
      check: false
    },{
      value: "餐饮补贴",
      check: false
    },{
      value: "住房补贴",
      check: false
    },{
      value: "一年13薪",
      check: false
    },{
      value: "交通补贴",
      check: false
    },{
      value: "常年恒温车间",
      check: false
    },{
      value: "加班补贴",
      check: false
    },{
      value: "节假日福利",
      check: false
    },{
      value: "免费班车接送",
      check: false
    }],
    workTimeTag: [ //工作经验
      "应届生",
      "1-3年",
      "3-5年",
      "5-10年",
      "10年以上",
      "不限"
    ],
    eduTag: ["初中及以下", "中专/技校", '高中', "大专", "本科", "硕士", "博士", "不限"], //学历
    languageTag: ["英语", "德语", "日语", "其他", "不限"], //外语选项
    langTag: [{ //默认语言选择
      level: 3,
      name: "英语"
    }],
    initLange: '英语',
    otherLang: true, //显示选择的语言
    otherLanguage: false, //显示新增语言输入框
    langLevel: [ //语言熟练度
      "简单沟通",
      "日常交流",
      "读写精通",
      "工作用语",
      "同声传译"
    ],
    // otherBtn: [ //专业证书
    //   "人力资源管理师证书",
    //   "企业培训师证书",
    //   "注册会计师证书",
    //   "会计从业资格证书"
    // ],
    knowBtn: [{
      value: "人力资源管理师证书",
      check: false
    }, {
      value: "企业培训师证书",
      check: false
    }, {
      value: "注册会计师证书",
      check: false
    }, {
      value: "会计从业资格证书",
      check: false
    }],
    // skillBtn: [ //工具工艺
    //   "APQP",
    //   "FMEA",
    //   "MSA",
    //   "PPAP",
    //   "SPC"
    // ],
    skillBtn: [{
      value: "APQP",
      check: false
    }, {
      value: "FMEA",
      check: false
    }, {
      value: "MSA",
      check: false
    }, {
      value: "PPAP",
      check: false
    }, {
      value: "SPC",
      check: false
    }],
    // toolBtn: ["AUTO-CAD软件", "Pro-E软件", "SAP", "金蝶", "用友"], //软件系统
    toolBtn: [{
      value: "AUTO-CAD软件",
      check: false 
    }, {
      value: "Pro-E软件",
      check: false
    }, {
      value: "SAP",
      check: false
    }, {
      value: "金蝶",
      check: false
    }, {
      value: "用友",
      check: false
    }],
    // otherBtn: [{
    //   value: "退伍军人",
    //   check: false 
    // }, {
    //   value: "军人家属",
    //   check: false
    // }, {
    //   value: "在校生",
    //   check: false
    // }, {
    //   value: "其他",
    //   check: false
    // }], //其他要求,
    // 军种
    armyType: ["海军", "陆军", "空军", "火箭军", "战略支援部队" ,"不限"],
    // 职务
    armyRole: ["班长", "排长", "营长", "连长", "团长", "师长", "军长", "不限"],
    // 军龄
    armyAge: ["2年", "3年", "4年", "5年", "8年", "12年", "更多", "不限"],
    // 身份
    armyIdentity: ["义务兵", "专业士官", "军官", "文职人员", "不限"],
    // 军队专业
    armyMajor: [{
      value: "航海",
      check: false
    }, {
      value: "帆缆",
      check: false
    }, {
      value: "电工",
      check: false
    }, {
      value: "舱段",
      check: false
    }, {
      value: "炊事员",
      check: false
    }, {
      value: "雷达",
      check: false
    }, {
      value: "报务",
      check: false
    }, {
      value: "信号",
      check: false
    }, {
      value: "驾驶员",
      check: false
    },{
      value: "保密员",
      check: false
    }, {
      value: "特种车辆驾驶员",
      check: false
    }, {
      value: "不限",
      check: false
    }],
    //职位信息
    jobInfo: {
      "entJobPay": "",
      "entJobFun": "",
      "entJobName": "",
      "entJobPart": "",
      "entJobAdd": "",
      "entJobNation": "",
      "entJobWorkTime": "",
      "entJobWorkTimeChecked": "0",
      "entJobPayChecked": "0",
      "entJobEdu": "不限",
      "entJobEduChecked": "0",
      "entJobLang": [{"name":"不限","level":3}],
      "entJobLangChecked": "0",
      "entJobIndustry": "",
      "entJobKnowTag": [],
      "entJobSkillTag": [],
      "entJobToolTag": [],
      "entJobOtherTag": [],
      "entJobReq": "",
      "entJobExplan": "岗位说明：\n\n\n任职要求：\n",
      "shortEntName": "",
      "entJobNum": 1,
      "entJobMinPay": 5,
      "entJobMaxPay": 8,
      "entJobPayMonth": 12,
      "entJobWorkType": "全职",
      "entWelfareTag": [],
      "entProcType": null,
      "entPorcMade": null,
      "entCustName": null,
      "entCustType": null,
      "entMassType": null,
      "entSell": null,
      "entIsOutTrip": null,
      "entOutName": null,
      "entWelfareInf": null,
      "hourPay": "",
      "coin": "",
      "jobid": "",
      "strArmyTitle": "",
      "strArmyMajor": [],
      "strArmyAge": "",
      // 时薪
      "hourpay": "",
    }
  },
  getters: {
    getJobInfo(state){
      return state.jobInfo;
    }
  },
  mutations: {
    setJobInit(state) { //重置数据
      state.jobInfo = {
        "entJobPay": "",
        "entJobFun": "",
        "entJobName": "",
        "entJobPart": "",
        "entJobAdd": "",
        "entJobNation": "",
        "entJobWorkTime": "",
        "entJobWorkTimeChecked": "0",
        "entJobPayChecked": "0",
        "entJobEdu": "不限",
        "entJobEduChecked": "0",
        "entJobLang": [{"name":"不限","level":3}],
        "entJobLangChecked": "0",
        "entJobIndustry": "汽车行业",
        "entJobKnowTag": [],
        "entJobSkillTag": [],
        "entJobToolTag": [],
        "entJobOtherTag": [],
        "entJobReq": "",
        "entJobExplan": "岗位说明：\n\n\n任职要求：\n",
        "shortEntName": "",
        "entJobNum": 1,
        "entJobMinPay": 5,
        "entJobMaxPay": 8,
        "entJobPayMonth": 12,
        "entJobWorkType": "全职",
        "entWelfareTag": [],
        "entProcType": null,
        "entPorcMade": null,
        "entCustName": null,
        "entCustType": null,
        "entMassType": null,
        "entSell": null,
        "entIsOutTrip": null,
        "entOutName": null,
        "entWelfareInf": null,
        "strArmyTitle": "",
        "strArmyMajor": [],
        "strArmyAge": "",
        "hourPay": "",
        "coin": "",
        "jobid": ""
      };
    },
    //修改状态下设置jobid
    setJobid(state, id) {
      state.jobid = id;
    },
    //修改状态下获取职位数据
   
    // 设置职位数据
    publishData(state, data){
      state.jobInfo = {
        "entJobPay": data.entJobPay,
        "entJobFun": data.entJobFun,
        "entJobName": data.entJobName,
        "entJobPart": data.entJobPart,
        "entJobAdd": data.entJobAdd,
        "entJobNation": data.entJobNation,
        "entJobWorkTime": data.entJobWorkTime,
        "strArmyTitle": data.strArmyTitle,
        "strArmyMajor": data.strArmyMajor ? data.strArmyMajor.split(",") : [],
        "strArmyAge": data.strArmyAge,
        "entJobWorkTimeChecked": "0",
        "entJobPayChecked": "0",
        "entJobEdu": data.entJobEdu,
        "entJobEduChecked": "0",
        "entJobLang": data.entJobLang,
        "entJobLangChecked": "0",
        "entJobIndustry": "汽车行业",
        "entJobKnowTag": data.entJobKnowTag,
        "entJobSkillTag": data.entJobSkillTag,
        "entJobToolTag": data.entJobToolTag,
        "entJobOtherTag": data.entJobOtherTag,
        "entJobReq": "",
        "entJobExplan": data.entJobExplan,
        "shortEntName": data.shortEntName,
        "entJobNum": data.entJobNum,
        "entJobMinPay": data.entJobMinPay,
        "entJobMaxPay": data.entJobMaxPay,
        "entJobPayMonth": data.entJobPayMonth,
        "entJobWorkType": data.entJobWorkType,
        "entWelfareTag": data.entWelfareTag,
        "entProcType": null,
        "entPorcMade": null,
        "entCustName": null,
        "entCustType": null,
        "entMassType": null,
        "entSell": null,
        "entIsOutTrip": null,
        "entOutName": null,
        "entWelfareInf": null,
        "hourPay": data.hourPay,
        "coin": data.coin,
        "jobid": data.jobid ? data.jobid : "",
      };
    }
  },
  actions:{
    //新增，修改职位
    funUploadJob: function (context, data) {
      xz.manipulateJob(data.entid, data.jobid, data.info).then((res) => {
        if(res){
          //获取审核列表
          xz.verityJob();
        }else{
          console.log("新增修改职位出错");
        }
      });
    },
  }
};

export default m_publish;